import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { getStoredRole, isUserAdminRole } from "../constants/roles";
import Navbar from "./navbar/Navbar";
import { Topbar } from "./navbar/Topbar";
import { RegistryView } from "../views/registry/RegistryView";
import { ActivityDetailsView } from "../views/registry/service/ActivityDetailsView";
import { ActivityEditView } from "../views/registry/service/ActivityEditView";
import { ActivityView } from "../views/registry/service/ActivityView";
import { MaterialDetailsView } from "../views/registry/service/MaterialDetailsView";
import { MaterialEditView } from "../views/registry/service/MaterialEditView";
import { MaterialView } from "../views/registry/service/MaterialView";
import { ServiceDetailsView } from "../views/registry/service/ServiceDetailsView";
import { ServiceEditView } from "../views/registry/service/ServiceEditView";
import { ServiceGroupDetailsView } from "../views/registry/service/ServiceGroupDetailsView";
import { ServiceGroupEditView } from "../views/registry/service/ServiceGroupEditView";
import { ServiceGroupView } from "../views/registry/service/ServiceGroupView";
import { ServiceView } from "../views/registry/service/ServiceView";
import { GroupView } from "../views/registry/group/GroupView";
import { FacilityView } from "../views/registry/facility/FacilityView";
import { FacilityEditView } from "../views/registry/customer/FacilityEditView";
import { UserView } from "../views/registry/customer/UserView";
import { UserMovementsView } from "../views/registry/customer/UserMovementsView";
import { DocumentView } from "../views/registry/document/DocumentView";
import { OverviewView } from "../views/home/OverviewView";
import { EvacuationView } from "../views/registry/evacuation/EvacuationView";
import { EvacuationDetailsView } from "../views/registry/evacuation/EvacuationDetailsView";
import { EvacuationEditView } from "../views/registry/evacuation/EvacuationEditView";
import { SettingsOverviewView } from "../views/registry/settings/SettingsOverviewView";
import { GeofenceSettingsView } from "../views/registry/settings/GeofenceSettingsView";
import { AlarmButtonsView } from "../views/registry/settings/AlarmButtonsView";
import AlarmsView from "../views/registry/alarm/AlarmsView";
import AlarmDetailsView from "../views/registry/alarm/AlarmDetailsView";
import { OrganisationsView } from "../views/registry/organisation/OrganisationsView";
import { OrganisationDetailsView } from "../views/registry/organisation/OrganisationDetailsView";

const AdminLayout = ({ sidebarOpen, setSidebarOpen }) => {
  // A user_admin may only reach overview + user management. Restricted routes
  // are not registered for them, and a catch-all sends any direct URL back to
  // the user list. (The backend independently enforces this — see
  // varna-server middleware requireAdminAccess.)
  const restrictedToUsers = isUserAdminRole(getStoredRole());

  return (
    <div className="main-container">
      <Navbar
        closeSidebar={() => {
          var element = document.getElementsByClassName("content-container");
          console.log(element);
          element[0].classList.remove("transform-content");
          setSidebarOpen(false);
        }}
        sidebarOpen={sidebarOpen}
      />
      <Topbar
        showSidebar={() => {
          var element = document.getElementsByClassName("content-container");
          console.log(element);
          element[0].classList.add("transform-content");
          setSidebarOpen(true);
        }}
      />

      <Routes>
        {/* Always available, including to a user_admin (groups are part of
            managing users) */}
        <Route index element={<OverviewView />} />
        <Route path="overview" element={<OverviewView />} />
        <Route path="user" element={<UserView />} />
        <Route path="user/movements/:id" element={<UserMovementsView />} />
        <Route path="group" element={<GroupView />} />

        {/* Everything below is off-limits to a user_admin */}
        {!restrictedToUsers && (
          <>
            <Route path="registry" element={<RegistryView />} />

            <Route path="facility" element={<FacilityView />} />
            <Route path="facility/edit/:id" element={<FacilityEditView />} />

            <Route path="document" element={<DocumentView />} />
            <Route path="evacuation">
              <Route index element={<EvacuationView />} />
              <Route path="details/:id" element={<EvacuationDetailsView />} />
              <Route path="edit/:id" element={<EvacuationEditView />} />
            </Route>

            <Route path="servicegroup">
              <Route index element={<ServiceGroupView />} />
              <Route path="overview/:id" element={<ServiceGroupDetailsView />} />
              <Route path="edit/:id" element={<ServiceGroupEditView />} />
            </Route>

            <Route path="service">
              <Route index element={<ServiceView />} />
              <Route path="overview/:id" element={<ServiceDetailsView />} />
              <Route path="edit/:id" element={<ServiceEditView />} />
            </Route>

            <Route path="activity">
              <Route index element={<ActivityView />} />
              <Route path="overview/:id" element={<ActivityDetailsView />} />
              <Route path="edit/:id" element={<ActivityEditView />} />
            </Route>

            <Route path="material">
              <Route index element={<MaterialView />} />
              <Route path="overview/:id" element={<MaterialDetailsView />} />
              <Route path="edit/:id" element={<MaterialEditView />} />
            </Route>

            <Route path="settings">
              <Route index element={<SettingsOverviewView />} />
              <Route path="geofence" element={<GeofenceSettingsView />} />
              <Route path="alarm-buttons" element={<AlarmButtonsView />} />
            </Route>

            <Route path="alarm">
              <Route index element={<AlarmsView />} />
              <Route path="details/:id" element={<AlarmDetailsView />} />
            </Route>

            {/* Superadmin-only — cross-organisation management */}
            <Route path="organisations">
              <Route index element={<OrganisationsView />} />
              <Route path=":id" element={<OrganisationDetailsView />} />
            </Route>
          </>
        )}

        {/* A user_admin who types a restricted URL is sent back to users */}
        {restrictedToUsers && (
          <Route path="*" element={<Navigate to="/admin/user" replace />} />
        )}
      </Routes>
    </div>
  );
};

export default AdminLayout;
